<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="4" :searchShow="true" @name="indexInit"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding:0.2em 3em 0em 3em">
        <!-- 右侧内容 -->
        <div class="specialistContent_right">
          <div class="specialistContent_right_title">
            <div class="title">搜索结果{{current}}</div>
          </div>
          <ul class="listBox" v-if="list.length > 0">
            <li v-for="item in list" :key="item.id" @click="goToDetail(item.id)">
              <img :src="$store.getters.imgUrl+item.logo" alt v-if="item.logo" />
              <!-- <img src="@/assets/image/equipment/3.png" alt="" v-else> -->
              <div class="NoLogoBox" v-else>
                <span>{{item.name}}</span>
              </div>
              <span class="company">{{item.enterpriseName}}</span>
              <span class="titleInfo">{{item.name}}</span>
              <!-- <span class="info">{{item.content}}</span> -->
              <!-- <div class="detail">
                <span>详情</span>
                <img src="@/assets/image/index/moreO.png" alt />
              </div> -->
              <div class="buttonZX">详情</div>
            </li>
            <li
              v-show="list.length%4>0"
              v-for="item in (4-list.length%4)"
              :key="item"
              class="addLi"
            ></li>
          </ul>
          <div class="pagination-wrapper">
          <Pagination  :replace="replace" name="产品与服务" :total="total*1" @change="changePagination"></Pagination>
          </div>
        </div>
      </div>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import Pagination from "@/components/pagination";
export default {
  name: "searchResult",
  components: {
    footCode,
    headTop,
    Pagination,
  },
  data() {
    return {
      replace: false,
      list: [],
      total: "", // 条数
      current: "", // 第几页
      limit: 12,
      page: 1,
      name: "",
      scrollTop:"",
    };
  },
  watch:{
    name (val) { // 监听数据总数total的改变在计算页码列表getPagesLength()
            this.replace = true
        },
  },
  activated() {
     this.$nextTick(() => {
      //恢复滚动高度
      console.log(this.$store.state.scrollTop);
      document
        .getElementsByClassName("specialistContent")[0]
        .scrollTo(0, this.$store.state.scrollTop);
    });
        
  },
 
    beforeRouteLeave(to, from, next) {
      this.scrollTop =document.getElementsByClassName("specialistContent")[0].scrollTop;
      this.$store.commit("changeScrollTop", this.scrollTop);
      console.log(this.scrollTop,"leave page");
      next();
    },
  mounted() {
    this.indexInit();
  },
  methods: {
    indexInit(value) {
        this.name = value || ''
      // 产品与服务
      this.ajaxUtil({
        method: "get",
        // url: '/apiAjax/api/home/index',
        url:
          this.$store.state.axiosUrl +
          `/api/home/v2/product/page?limit=${this.limit}&page=${this.page}&name=${this.name}`,
        // params: {},
      }).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    goToDetail(id) {
      this.$router.push({
        path: "/case/caseDetail",
        query: { 
			id:id,
			index:2,
		 },
      });
    },
    pageTO(_item) {
      // 新页打开
      console.log(_item.fileUrl);
      if (_item.fileUrl) window.open(_item.fileUrl);
    },
    changePagination(current) {
      this.page = current;
      this.indexInit(this.name);
    },
  },
};
</script>
<style scoped lang="less">
@import url("~@/assets/css/index.less");
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  // overflow: auto;
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;

      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
      .title {
        color: #2579bf;
        font-size: 16px;
        padding-bottom: 5px;
        border-bottom: 4px solid #2579bf;
      }
    }
    //   列表
    .listBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        position: relative;
        width: 24%;
        padding-bottom: 0em;
        margin-top: 20px;
        cursor: pointer;
        .titleInfo {
          color: #2579bf;
          font-size: 0.83em;
          font-weight: 600;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          padding: 10px;
          height: 54px;
          line-height: 23px;
        }
        img {
          height: 10em;
          width: 100%;
        }
        span {
          font-size: 0.15em;
          padding: 5px 10px;
          
        }
        .company {
          position: absolute;
          top:53em;
          left: 0;
          width: 100%;
          padding: 10px;
          white-space: nowrap;
          background-color: rgba(0, 0, 0, 0.4);
          color: #fff;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
        .info {
          padding: 5px 10px;
           padding-top: 20px;
          padding-bottom: 20px;
          overflow: hidden;
          font-size: 0.15em;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #555;
        }
        //详情
        .detail {
          font-size: 0.16em;
          color: #ff7920;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: absolute;
          right: 10px;
          bottom: 50px;
          cursor: pointer;
          span {
            padding: 0;
            margin-right: 5px;
          }
          img {
            height: 10px;
            width: 10px;
          }
        }
      }
    }
    .pagination-wrapper{
      
      margin-top: 15px;
      margin-bottom: 40px;
    }
  }
}
.footer {
  width: 100%;
  // margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
}
.addLi {
  border: none !important;
}
.buttonZX {
  text-align: center;
  padding: 7px;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  color: #fff;
  margin-top: 10px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 100%;
}
.NoLogoBox {
  background-image: url("~@/assets/image/equipment/3.png");
  background-size: cover;
  height: 10em;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: hzgb;
  align-items: center;
  text-align: -webkit-center;
  span {
    margin-top: -20px;
    font-size: 13px !important;
    font-weight: 600;
    letter-spacing: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/searchResult.vue